module.exports = __webpack_public_path__ + "static/img/286.b423832.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/286.png
// module id = /NUU
// module chunks = 0